<template>
    <div class="fill-height of-y d-flex align-start" style="overflow-x: hidden">

        <v-expand-x-transition>
            <div class="px-2 fill-height of-y flex-grow-1 flex-equal" style="max-width: 35%">
                <template v-for="team in filteredTeams">
                    <div class="pa-2">
                        <v-card
                                class="d-flex align-center"
                                :key="team._id"
                                @click.self="$store.state.ref.teams.selected = $store.state.ref.teams.selected === team ? null : team"
                                :raised="$store.state.ref.teams.selected === team"
                                hover
                        >
                            <div class="ml-2" @click.self="$store.state.ref.teams.selected = $store.state.ref.teams.selected === team ? null : team">
                                <template v-if="$store.state.ref.teams.selected === team">
                                    <v-icon color="primary">mdi-check-circle</v-icon>
                                </template>
                                <template v-else>
                                    <v-icon color="grey">mdi-checkbox-blank-circle-outline</v-icon>
                                </template>
                            </div>

                            <div class="subtitle-1 font-weight-light pa-2 flex-grow-1 flex-equal" @click.self="$store.state.ref.teams.selected = $store.state.ref.teams.selected === team ? null : team">
                                {{team.name}}
                            </div>

                            <div class="body-2 font-weight-light pa-2 d-flex align-center" @click.self="$store.state.ref.teams.selected = $store.state.ref.teams.selected === team ? null : team">
                                <app-outlined-chip
                                        :label="`${employeesByTeam[team._id] ? employeesByTeam[team._id].length : 0} Employee${employeesByTeam[team._id] && employeesByTeam[team._id].length === 1 ? '' : 's'}`"
                                        icon="mdi-account"
                                        color="primary"
                                />
                            </div>

<!--                            <v-speed-dial-->
<!--                                    class="pa-0 ma-0 mr-3"-->
<!--                                    direction="left"-->
<!--                                    open-on-hover-->
<!--                            >-->
<!--                                <template v-slot:activator>-->
<!--                                    <v-btn-->
<!--                                            color="primary"-->
<!--                                            dark-->
<!--                                            small-->
<!--                                            icon-->
<!--                                    >-->
<!--                                        <v-icon>-->
<!--                                            mdi-cog-->
<!--                                        </v-icon>-->
<!--                                    </v-btn>-->
<!--                                </template>-->

<!--                                <v-tooltip top>-->
<!--                                    <template v-slot:activator="{on}">-->
<!--                                        <v-btn-->
<!--                                                class="indigo"-->
<!--                                                color="white"-->
<!--                                                icon-->
<!--                                                v-on="on"-->
<!--                                                @click="(event) => {-->
<!--                                                    event.preventDefault()-->
<!--                                                    $store.state.ref.teams.selected = team-->
<!--                                                    $nextTick(() => {-->
<!--                                                        $refs.sidebar.showAddEmployees = true;-->
<!--                                                    })-->
<!--                                                }"-->
<!--                                        >-->
<!--                                            <v-icon>mdi-plus</v-icon>-->
<!--                                        </v-btn>-->
<!--                                    </template>-->
<!--                                    Add Employees-->
<!--                                </v-tooltip>-->

<!--                                <v-tooltip top>-->
<!--                                    <template v-slot:activator="{on}">-->
<!--                                        <v-btn-->
<!--                                                class="green"-->
<!--                                                color="white"-->
<!--                                                icon-->
<!--                                                v-on="on"-->
<!--                                                @click="-->
<!--                                                (event) => {-->
<!--                                                    event.preventDefault()-->
<!--                                                    $store.state.ref.teams.selected = team-->
<!--                                                    $nextTick(() => {-->
<!--                                                        $refs.sidebar.showRenameTeam = true;-->
<!--                                                    })-->
<!--                                                }"-->
<!--                                        >-->
<!--                                            <v-icon>mdi-pencil</v-icon>-->
<!--                                        </v-btn>-->
<!--                                    </template>-->
<!--                                    Rename Team-->
<!--                                </v-tooltip>-->

<!--                                <v-tooltip top>-->
<!--                                    <template v-slot:activator="{on}">-->
<!--                                        <v-btn-->
<!--                                                class="red"-->
<!--                                                color="white"-->
<!--                                                icon-->
<!--                                                v-on="on"-->
<!--                                                @click="(event) => {-->
<!--                                                    event.preventDefault()-->
<!--                                                    $store.state.ref.teams.selected = team-->
<!--                                                    $nextTick(() => {-->
<!--                                                        $refs.sidebar.showConfirmDelete = true-->
<!--                                                    })-->
<!--                                                }"-->
<!--                                        >-->
<!--                                            <v-icon>mdi-delete</v-icon>-->
<!--                                        </v-btn>-->
<!--                                    </template>-->
<!--                                    Delete Team-->
<!--                                </v-tooltip>-->
<!--                            </v-speed-dial>-->

                        </v-card>
                    </div>
                </template>
            </div>
        </v-expand-x-transition>


        <v-slide-x-reverse-transition>
            <div v-if="selectedTeam" class="fill-height" style="width: 65%">
                <app-teams-side-bar :selected-team="selectedTeam" ref="sidebar"/>
            </div>
        </v-slide-x-reverse-transition>


        <app-team-add v-if="$store.state.ref.teams.showAdd" :shown.sync="$store.state.ref.teams.showAdd" @input="$store.state.ref.teams.selected = $event"/>

    </div>
</template>

<script>
import {mapGetters} from "vuex";
import AppTeamAdd from "@/components/Teams/AppTeamAdd";
import AppTeamsSideBar from "@/components/Teams/AppTeamsSideBar";
import AppOutlinedChip from "@/components/Shared/AppOutlinedChip";
import {nameSort} from "@/core/codeFunctions";

export default {
    components: {
        AppOutlinedChip,
        AppTeamsSideBar,
        AppTeamAdd,
    },
    props: {
        shown: Boolean
    },
    data() {
        return {

        }
    },
    created() {
        this.teams.on('deleted', this.deleteWatch)
    },
    beforeDestroy() {
        this.teams.off('deleted', this.deleteWatch)
    },
    watch: {

    },
    methods: {
        deleteWatch(team) {
            if (this.$store.state.ref.teams.selected === team)
                this.$store.state.ref.teams.selected = null
        }
    },
    computed: {
        ...mapGetters(['teams', 'employeesByTeam', 'teamsWithAccess']),
        selectedTeam() {
            return this.$store.state.ref.teams.selected
        },

        filteredTeams() {
            if (!this.$store.state.ref.teams.filterStr)
                return [...this.teamsWithAccess]
                        .sort(nameSort)

            return this.teamsWithAccess.filter((team) => {
                const str = `${JSON.stringify(team)}${JSON.stringify(this.employeesByTeam[team._id] || {})}`
                return str.toLowerCase().includes((this.$store.state.ref.teams.filterStr || '').toLowerCase())
            }).sort(nameSort)
        }
    },
}
</script>

<style scoped>

</style>